import { defineComponent, useListeners, inject, computed } from 'vue';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';
import { useStoreModule } from '../../composables/store-module/index.js';
import { useTableRow } from '../../composables/table-row/index.js';
import UiBreakdown from '../ui-breakdown/UiBreakdown.vue.js';
import HoistComponent from '../hoist-component/HoistComponent.vue.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PortfolioBreakdown",
  props: {
    locale: { type: null, required: true },
    id: { type: null, required: true },
    breakdownType: { type: null, required: true },
    chartType: { type: null, required: false, default: "pie" },
    highlightMinWeight: { type: Number, required: false },
    highlightMaxItems: { type: Number, required: false },
    highlightMode: { type: null, required: false, default: "detail" },
    tableDisplayOthers: { type: Boolean, required: false, default: false },
    chartDisplayOthers: { type: Boolean, required: false, default: true },
    legendType: { type: null, required: false, default: "counting" }
  },
  emits: ["store-error", "data-load", "table-row-key-click", "table-row-click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const listeners = useListeners();
    const chartOptions = inject("chart");
    const componentInputs = computed(() => ({
      id: props.id,
      breakdownType: props.breakdownType,
      language: props.locale
    }));
    const translationKeys = computed(() => ({
      table: {
        caption: "portfolioBreakdown.table.caption",
        name: `portfolioBreakdown.table.name.${props.breakdownType}`
      },
      chart: {
        counting: `portfolioBreakdown.chart.counting.${props.breakdownType}`,
        topPositions: `portfolioBreakdown.chart.topPositions.${props.breakdownType}`
      }
    }));
    const positions = computed(() => {
      var _a;
      return (_a = storeData.value) != null ? _a : void 0;
    });
    const getName = (bindings) => bindings.name;
    const uiBreakdownEvents = () => {
      const events = {};
      if (hasTableRowClickListener.value) {
        events["table-row-click"] = (item) => {
          onTableRowClick(item);
        };
      }
      if (hasTableRowKeyClickListener.value) {
        events["table-row-key-click"] = (item) => {
          onTableRowKeyClick(item);
        };
      }
      return events;
    };
    const localizationSupport = useLocalizationSupport(props, {
      translator: inject("translator"),
      numberFormatter: inject("numberFormatter"),
      dateFormatter: inject("dateFormatter")
    });
    const { translate, textFormat } = localizationSupport;
    const tableRow = useTableRow(listeners, emits);
    const { hasTableRowClickListener, hasTableRowKeyClickListener, onTableRowKeyClick, onTableRowClick } = tableRow;
    const storeModule = useStoreModule(
      { storeModule: inject("storeModule") },
      componentInputs,
      emits
    );
    const { storeData, isLoadingStoreData } = storeModule;
    return { __sfc: true, props, emits, listeners, chartOptions, componentInputs, translationKeys, positions, getName, uiBreakdownEvents, localizationSupport, translate, textFormat, tableRow, hasTableRowClickListener, hasTableRowKeyClickListener, onTableRowKeyClick, onTableRowClick, storeModule, storeData, isLoadingStoreData, UiBreakdown, HoistComponent };
  }
});

export { _sfc_main as default };
